import Input from './defaultFormInput/Input';
import PhoneInput from './phoneInput/PhoneInput';

export const DefaultFormInput = Input;
export const ReactPhoneInput = PhoneInput;
